import { render, staticRenderFns } from "./FaqCreate.vue?vue&type=template&id=3a2eda73&scoped=true&"
import script from "./FaqCreate.vue?vue&type=script&lang=js&"
export * from "./FaqCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2eda73",
  null
  
)

export default component.exports